import React, { useEffect, useRef, useState } from "react";
import { Card, Spinner, Form, Row, Col } from "@themesberg/react-bootstrap";
import { Button, ButtonGroup } from "@themesberg/react-bootstrap";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { fetchApi } from "../../../redux/api";
import { formatNumber } from "../../../redux/utils";
import moment from "moment";

const headerColors = [
  "#999",
  "#ccc",
  "#eee",
  "#f2f2f2",
  "#f5f5f5",
  "#f9f9f9",
];

function unflattenTable(arr) {
  var tree = [],
    mappedArr = {},
    arrElem,
    mappedElem;

  for (var i = 0, len = arr?.length; i < len; i++) {
    arrElem = arr[i];
    if (arrElem?.code) {
      mappedArr[arrElem.code] = { ...arrElem, children: [] };
    }
  }

  for (var i = 0, len = arr?.length; i < len; i++) {
    arrElem = arr[i];
    mappedElem = mappedArr[arrElem.code];

    if (mappedElem) {
      const parentHeads = [];
      let currentParent = mappedElem;
      while (currentParent?.sub_head) {
        parentHeads.unshift(currentParent?.sub_head);
        currentParent = mappedArr[currentParent?.sub_head];
      }
      const childWithProperty = { ...mappedElem, parentHeads };

      if (mappedElem?.sub_head) {
        if (mappedArr[mappedElem.sub_head]) {
          mappedArr[mappedElem.sub_head].children.push(childWithProperty);
        } else {
          tree.push(childWithProperty);
        }
      } else {
        tree.push(childWithProperty);
      }
    }
  }

  return tree;
}

function ensureNumber(value) {
  return isNaN(value) || value === null || value === undefined
    ? 0
    : Number(value);
}

export default function ReportTotalEconomic({
  type = "mda_expenditure_by_eco",
  route = "/reports",
  options = [],
  title = "Expenditure by Economic",
}) {
  const [treeData, setTreeData] = useState([]);
  const [form, setForm] = useState({
    budget_year: moment().format("YYYY"),
  });
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    value: type,
    title,
  });
  const years = Array.from({ length: 10 }, (_, i) =>
    moment().format("YYYY") - i
  );
  const tableRef = useRef(null);

  const handleChange = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleButtonClick = (value, title) => {
    setSelectedOption({ value, title });
  };

  const likeVar = selectedOption?.title.includes("Personnel")
    ? "21%"
    : selectedOption?.title.includes("Debt")
    ? "2206%"
    : selectedOption?.title.includes("Capital")
    ? "32%"
    : selectedOption?.title.includes("Over-head")
    ? "22%"
    : null;

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({
      query_type: selectedOption.value,
      budget_year: form.budget_year,
    });
    if (likeVar) {
      params.append("like", likeVar);
    }
    fetchApi(`reports?${params.toString()}`)
      .then((data) => {
        const rows = data?.results || [];
        const modifiedResults = [...rows];
        const adminSegmentIndex = modifiedResults.findIndex(
          (item) => item.description === "Administative segment"
        );
        if (adminSegmentIndex !== -1) {
          modifiedResults[adminSegmentIndex].sub_head = "";
          modifiedResults[adminSegmentIndex].code = "";
        }
        const tt = unflattenTable(modifiedResults);
        setTreeData(tt);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [form.budget_year, selectedOption.value, likeVar]);

  const calculateprevyear = (node) => {
    if (!node.children || node.children.length === 0) {
      return ensureNumber(node.prev_year2_actual_amount);
    }
    let sum = ensureNumber(node.prev_year2_actual_amount);
    for (const child of node.children) {
      sum += calculateprevyear(child);
    }
    return sum;
  };

  const calculateApprovePrev1 = (node) => {
    if (!node.children || node.children.length === 0) {
      return ensureNumber(node.prev_year1_approve_amount);
    }
    let sum = ensureNumber(node.prev_year1_approve_amount);
    for (const child of node.children) {
      sum += calculateApprovePrev1(child);
    }
    return sum;
  };

  const calculateActualPrev1 = (node) => {
    if (!node.children || node.children.length === 0) {
      return ensureNumber(node.prev_year1_actual_amount);
    }
    let sum = ensureNumber(node.prev_year1_actual_amount);
    for (const child of node.children) {
      sum += calculateActualPrev1(child);
    }
    return sum;
  };

  const calculateBudgetAmt = (node) => {
    if (!node.children || node.children.length === 0) {
      return ensureNumber(node.budget_amount);
    }
    let sum = ensureNumber(node.budget_amount);
    for (const child of node.children) {
      sum += calculateBudgetAmt(child);
    }
    return sum;
  };

  const calculateAdjustment = (node) => {
    if (!node.children || node.children.length === 0) {
      return ensureNumber(node.supplementary_amount);
    }
    let sum = ensureNumber(node.supplementary_amount);
    for (const child of node.children) {
      sum += calculateAdjustment(child);
    }
    return sum;
  };

  const calculateApproveAmt = (node) => {
    if (!node.children || node.children.length === 0) {
      return ensureNumber(node.approve_amount);
    }
    let sum = ensureNumber(node.approve_amount);
    for (const child of node.children) {
      sum += calculateApproveAmt(child);
    }
    return sum;
  };

  const newFilterHead = (item) => {
    const isEmptyValue = (v) =>
      v === 0 || v === null || v === undefined || v === "--" || v === "0.00" || v === "";
    return (
      isEmptyValue(calculateprevyear(item)) &&
      isEmptyValue(calculateApprovePrev1(item)) &&
      isEmptyValue(calculateActualPrev1(item)) &&
      isEmptyValue(calculateBudgetAmt(item)) &&
      isEmptyValue(calculateApproveAmt(item))
    );
  };

  const newFilterChild = (item) => {
    const isEmptyValue = (v) =>
      v === 0 || v === null || v === undefined || v === "--" || v === "0.00" || v === "";
    return (
      isEmptyValue(item.prev_year2_actual_amount) &&
      isEmptyValue(item.prev_year1_approve_amount) &&
      isEmptyValue(item.prev_year1_actual_amount) &&
      isEmptyValue(item.budget_amount) &&
      isEmptyValue(item.supplementary_amount)
    );
  };

  const _title =
    type === "mda_expenditure_by_eco"
      ? "Total Expenditure By Economic"
      : "Total Revenue By Economic";

  const renderItems = (item, index) => {
    const isTitle =
      item.code === "0000000000000000000" ||
      item.code === "1000000000000000000" ||
      item.code === "2000000000000000000" ||
      item.code === "3000000000000000000" ||
      item.code === "5000000000000000000" ||
      item.code === "7000000000000000000" ||
      item.code === "8000000000000000000";

    return (
      <React.Fragment key={`group_${index}`}>
        {!newFilterHead(item) && (
          <tr
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              color: "black",
              cursor: "pointer",
            }}
          >
            <td
              style={{
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {isTitle ? "" : item.code?.replace(/0+$/, "")}
            </td>
            <td
              style={{
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {isTitle ? _title : item.description}
            </td>
            <td
              style={{
                textAlign: "right",
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {formatNumber(calculateprevyear(item))}
            </td>
            <td
              style={{
                textAlign: "right",
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {formatNumber(calculateApprovePrev1(item))}
            </td>
            <td
              style={{
                textAlign: "right",
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {formatNumber(calculateActualPrev1(item))}
            </td>
            <td
              style={{
                textAlign: "right",
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {formatNumber(calculateBudgetAmt(item))}
            </td>
            <td
              style={{
                textAlign: "right",
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {formatNumber(calculateAdjustment(item))}
            </td>
            <td
              style={{
                textAlign: "right",
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {formatNumber(calculateApproveAmt(item))}
            </td>
          </tr>
        )}

        {item.children?.map((child, idx) => {
          if (child.children?.length) {
            return renderItems(child, idx);
          }
          if (newFilterChild(child)) return null;
          return (
            <tr key={child.code || idx} style={{ fontSize: "11px" }}>
              <td>{child.code}</td>
              <td>{child.description}</td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(child.prev_year2_actual_amount)}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(child.prev_year1_approve_amount)}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(child.prev_year1_actual_amount)}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(child.budget_amount)}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(child.supplementary_amount)}
              </td>
              <td style={{ textAlign: "right" }}>
                {isNaN(child.approve_amount)
                  ? "---"
                  : formatNumber(child.approve_amount)}
              </td>
            </tr>
          );
        })}
      </React.Fragment>
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>{selectedOption.title}</h4>
        </div>
      </div>

      <Card border="light" className="shadow-sm">
        <Card.Body>
          <Row className="mb-3">
            <Col md={2}>
              <Form.Group>
                <Form.Label>Budget Year</Form.Label>
                <Form.Select
                  name="budget_year"
                  value={form.budget_year}
                  onChange={handleChange}
                >
                  <option>--select--</option>
                  {years.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={8} className="text-center">
              <ButtonGroup>
                <Button
                  size="sm"
                  variant={
                    selectedOption.title === title
                      ? "primary"
                      : "outline-secondary"
                  }
                  onClick={() => handleButtonClick(type, title)}
                >
                  <small>{title}</small>
                </Button>
                {options.map((item) => (
                  <Button
                    size="sm"
                    key={item.title}
                    variant={
                      selectedOption.title === item.title
                        ? "primary"
                        : "outline-secondary"
                    }
                    onClick={() =>
                      handleButtonClick(item.value, item.title)
                    }
                  >
                    <small>{item.title}</small>
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
            <Col
              md={2}
              className="d-flex align-items-end justify-content-end"
            >
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => {
                  if (tableRef.current) {
                    const ws = XLSX.utils.table_to_sheet(tableRef.current);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(
                      wb,
                      ws,
                      selectedOption.title
                    );
                    const buf = XLSX.write(wb, {
                      bookType: "xlsx",
                      type: "array",
                    });
                    FileSaver.saveAs(
                      new Blob([buf], {
                        type: "application/octet-stream",
                      }),
                      `${selectedOption.title}.xlsx`
                    );
                  }
                }}
              >
                <FontAwesomeIcon icon={faFileDownload} className="me-1" />{" "}
                Download Excel
              </Button>
            </Col>
          </Row>

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="table-responsive">
              <table
                className="table table-bordered"
                ref={tableRef}
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      backgroundColor: "orange",
                    }}
                  >
                    <th style={{ backgroundColor: "orange" }}>Code</th>
                    <th style={{ backgroundColor: "orange" }}>Description</th>
                    <th style={{ backgroundColor: "orange" }}>{`${
                      parseInt(form.budget_year) - 2
                    } Full Year Actual`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${
                      parseInt(form.budget_year) - 1
                    } Approved Budget`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${
                      parseInt(form.budget_year) - 1
                    } Performance Jan-Aug`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${parseInt(
                      form.budget_year
                    )} MDA Proposal`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${parseInt(
                      form.budget_year
                    )} Adjustments`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${parseInt(
                      form.budget_year
                    )} Approved Budget`}</th>
                  </tr>
                </thead>
                <tbody>
                  {treeData.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center py-4">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    treeData.map((item, i) => renderItems(item, i))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
